import styled from "styled-components";

const Container = styled.div`
  cursor: pointer;
  padding: 16px 20px;
  border-radius: 12px;
  box-shadow: rgba(46, 56, 68, 0.1) 0px 4px 12px;
  width: 100%;
  border: 1px solid transparent;
  transition: 300ms;
  &:hover {
    border: 1px solid var(--neutrals-light-gray);
  }
`;


const Title = styled.p`
  font-size: 18px;
  font-weight: 700;
  color: var(--neutrals-charcoal);
  margin-top: 40px;
`;
const ClientName = styled.p`
  color: var(--neutrals-slate-gray);
  font-size: 14px;
  margin-bottom: 40px;
`;


//---- T A G S ----//
const TagsContainer = styled.div`
  border-top: 1px solid var(--neutrals-light-gray);
  width: 100%;
  padding: 10px 0 0 0;
  display: flex;
  justify-content: flex-end;
  gap: 6px;
`;

const Tag = styled.button`
  cursor: pointer;
  border: 1px solid var(--secondary-maya-blue);
  background-color: var(--secondary-alice-blue);
  padding: 4px 8px;
  border-radius: 32px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--primary-royal-blue);
  font-size: 12px;
  transition: 300ms;
  &:hover {
    opacity: 0.8;
  }
`;

export const CardSiniestros = ({
  id,
  numeroSiniestro,
  notaSeguimiento,
  estatus,
  onClicked,
}) => {
  return (
    <Container onClick={()=>{onClicked(id)}}>
      <Title>  Siniestro #{String(numeroSiniestro).padStart(4,'0')}</Title>
      <ClientName>{notaSeguimiento}</ClientName>
      <TagsContainer>
        <Tag>Estatus del siniestro: {estatus}</Tag>
      </TagsContainer>
    </Container>
  );
};
